    <div [@routerTransition] [busyIf]="isLoading" id="my-profile-component" class="myprofile_wrappern card rounded-0 card-custom pb-4 pt-4 p-4 h-100">

    <div class="container-fluid p-2">
        <div class="card border-0">
            <div class="card-header">
                <h6>
                    <b> {{"MyProfile" | localize}}</b>
                </h6>
                <small>
                    {{'UpdateyourpersonalInformation' | localize}}
                </small>
            </div>
            <div class="card-body p-2">

                <form #myProfileForm="ngForm" id="myProfileForm" novalidate>
                    <div class="row">
                        <div class="col-md-2 col-lg-2 col-xl-2 pl-0">
                            <div class="form-group">
                                <div class="image-input-wrapper profile-pic-wrapper ">
                                    <div *ngIf="showImg">
                                        <img class=" img-fluid rounded" style="width: 110px;height: 110px;"
                                            [src]=" imagePath? imagePath : 'assets/common/images/default-profile-picture1.svg'" />
                                    </div>
                                    <div *ngIf=" !imagePath ">
                                        <label class="mt-3 ml-1" title="" data-original-title="Change avatar"
                                         a href=""  (click)="showSideBar()">
                                            <a class="blue cursor-pointer">
                                                {{'UploadPhoto' | localize}} {{imagePath}}
                                            </a>
                                        </label>
                                    </div>
                                    <div *ngIf=" imagePath">
                                        <label class="mt-3" (click)="deletePicture()" data-toggle="tooltip"
                                            [style.display]="imagePath === '' ? 'none' : ''" title="">
                                            <a class="blue cursor-pointer ml-3">
                                                {{'RemovePhoto' | localize}}
                                            </a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9 col-xl-9 col-lg-9">
                            <div class="row">

                                <div class="col-md-6 col-xl-6 col-lg-6">
                                    <label>{{'FirstName' | localize}}<span class="required text-danger">*</span>
                                    </label>
                                    <input class="form-control rounded-0" type="text" name="firstName"
                                        #firstName="ngModel" [(ngModel)]="myProfileData.firstName"
                                        placeholder="{{'EnterFirstName' | localize}}" value=""
                                        [ngClass]="{'borderRed ' : myProfileForm.submitted && firstName.invalid}"
                                        maxlength="25" autocomplete="nope" required>
                                    <div *ngIf="myProfileForm.submitted" class="text-danger">

                                        <span *ngIf="firstName.invalid && firstName.errors.required">
                                            {{'Firstnameismandatory' | localize}}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xl-6 col-lg-6">
                                    <label>{{'LastName' | localize}}<span class="required text-danger">*</span> </label>
                                    <input class="form-control rounded-0" type="text" #lastName="ngModel"
                                        placeholder="{{'EnterLastName' |localize }}"
                                        [(ngModel)]="myProfileData.lastName"
                                        [ngClass]="{'borderRed ' : myProfileForm.submitted && lastName.invalid}"
                                        maxlength="25" autocomplete="nope" name="lastName" required>
                                    <div *ngIf="myProfileForm.submitted" class="text-danger">
                                        <span *ngIf="lastName.invalid && lastName.errors.required">
                                            {{'Lastnameismandatory' | localize}}
                                        </span>

                                        <span *ngIf="lastName.errors?.maxlength">
                                            {{'Lastnamecannotbegreaterthancharacters' | localize}}
                                        </span>

                                    </div>
                                </div>


                                <div class="col-md-6  col-xl-6 col-lg-6 mt-3">
                                    <div class="">
                                        <label> {{'EmailID' | localize}}<span
                                                class="required text-danger">*</span></label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text rounded-0">
                                                    <i class="flaticon-email"></i>
                                                </span>
                                            </div>
                                            <input class="form-control rounded-0" id="EmailAddress" type="email"
                                                name="emailAddress" #emailAddressInput="ngModel" disabled="disabled"
                                                [(ngModel)]="myProfileData.emailAddress" maxlength="256" email>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xl-6 col-lg-6 mt-3">
                                    <div class="">
                                        <label> {{'EmployeeId' | localize}}</label>
                                        <div class="input-group">
                                            <!-- <div class="input-group-prepend">
                                                <span class="input-group-text rounded-0">
                                                    <i class="flaticon-email"></i>
                                                </span>
                                            </div> -->
                                            <input class="form-control rounded-0" id="empId" type="text"
                                                name="empId" #emailAddressInput="ngModel" disabled="disabled"
                                                [(ngModel)]="myProfileData.employeeId" maxlength="256">
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="col-md-12 mb-2">
                                    <div *ngIf="isSocial" class="">
                                        <div *ngIf="isGranted('Pages.MyProfile.EmailHide')">
                                            <div class="" *ngIf="!showEmail">
                                                <a (click)="showEmail =!showEmail"
                                                   class="blue pointer-event cursor-pointer">{{'ChangeEmailAddress' | localize}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-12 mb-2">
                                    <div class="form-group " *ngIf="showEmail">
                                        <div class="">

                                            <input id="confirmEmailAddressInput" type="text" name="confirmEmailAddressInput"
                                                   class="form-control rounded-0" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$" #confirmEmailAddressInput="ngModel"
                                                   [(ngModel)]="confirmEmail" placeholder="{{'New Email ID' | localize}}"
                                                   validateEqual="newEmailAddressInput" reverse="false"
                                                   autocomplete="new-password" required maxlength="256" (click)="EmailValid()">

                                            <div *ngIf="emailValidError">
                                                <span class="form-text text-danger">
                                                    {{"Email Address cannot be Empty" | localize}}
                                                </span>
                                            </div>

                                            <div *ngIf="confirmEmailAddressInput.errors?.pattern">
                                                <span class="form-text text-danger">
                                                    {{"Enter Valid Email Address" | localize}}
                                                </span>
                                            </div>-->
                                <!--  <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
                                                <ul class="form-text text-danger" *ngIf="confirmEmailAddressInput.errors && myProfileForm.submitted">
                                                    <li [hidden]="confirmEmailAddressInput.valid">{{"EmailAddressDoesNotMatch" | localize}}</li>
                                                </ul>
                                            </div>-->

                                <!--</div>


                                        <div class="mt-4">

                                            <input id="confirmEmailAddressInputLast" type="email" name="email"
                                                   class="form-control rounded-0" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" #confirmEmailAddressInputLast="ngModel"
                                                   [(ngModel)]="newEmailId" placeholder="{{'ConfirmNewEmailID' | localize}}"
                                                   required maxlength="200">

                                            <div *ngIf="emailValidError">
                                                <span class="form-text text-danger">
                                                    {{"Email Address cannot be Empty" | localize}}
                                                </span>
                                            </div>

                                            <div *ngIf="confirmEmailAddressInputLast.errors?.pattern">
                                                <span class="form-text text-danger">
                                                    {{"Enter Valid Email Address" | localize}}
                                                </span>
                                            </div>

                                            <div>
                                                <div *ngIf="isEmailNotsame">
                                                    <span class="form-text text-danger">
                                                        {{"Email Address not same" | localize}}
                                                    </span>
                                                </div>
                                            </div>

                                            <div *ngIf="EmailCheck">
                                                <span class="form-text text-danger">
                                                    {{"Email Address already exist" | localize}}
                                                </span>
                                            </div>-->

                                <!-- <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
                                                <ul class="form-text text-danger" *ngIf="confirmEmailAddressInput.errors && myProfileForm.submitted">
                                                    <li [hidden]="confirmEmailAddressInput.valid">{{"EmailAddressDoesNotMatch" | localize}}</li>
                                                </ul>
                                            </div>-->

                                <!--</div>

                                        <div class="mt-2" (click)="showEmail =!showEmail" *ngIf="showEmail">
                                            <a (click)="datadisplay()" class="cursor-pointer anchor-color">
                                                {{'Cancel' | localize}}
                                            </a>
                                        </div>
                                    </div>
                                </div>-->


                                <div *ngIf="isSocial" class="col-md-12 mt-3">
                                    <div class="">
                                        <!-- <div *ngIf="!showPassword">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text rounded-0">
                                                        <i class="fa cursor-pointer"
                                                        [ngClass]="{'fa-eye-slash': fieldTextType,'fa-eye': !fieldTextType}"
                                                        (click)="toggleFieldTextType()"></i>
                                                    </span>
                                                </div>
                                                <input type="password" class="form-control rounded-0"
                                                aria-describedby="basic-addon1" [(ngModel)]="myProfileData.password"
                                                [type]="fieldTextType ? 'text' : 'password'">
                                            </div>
                                        </div> -->
                                        <div *ngIf="showPassword">
                                            <label>{{'CurrentPassword' | localize}}</label>
                                            <div class="input-group">
                                                <input id="CurrentPassword" #currentPasswordInput="ngModel"
                                                    value="currentPasswordInput" type="password" name="CurrentPassword"
                                                    placeholder="{{'CurrentPassword' | localize}}"
                                                    class="form-control rounded-0"
                                                    [ngClass]="{'borderRed ' : incorrectCurrentPassword || (currentPasswordInput.touched && currentPasswordInput.errors?.required)}"
                                                    [type]="fieldTextType ? 'password' : 'text'" autocomplete="off"
                                                    [(ngModel)]="currentPassword"
                                                    (ngModelChange)="currentPasswordChanged()" required>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text rounded-0">
                                                        <i class="fa cursor-pointer"
                                                            [ngClass]="{'fa-eye-slash': fieldTextType,'fa-eye': !fieldTextType}"
                                                            (click)="toggleFieldTextType()"></i>
                                                    </span>
                                                </div><br>
                                            </div>
                                            <div *ngIf="incorrectCurrentPassword">
                                                <span class="my-profile-password-change-validation">
                                                    {{'MyProfileIncorrectCurrentPassword' | localize}}
                                                </span>
                                            </div>
                                            <div
                                                *ngIf="currentPasswordInput.touched && currentPasswordInput.errors?.required">
                                                <span class="my-profile-password-change-validation">
                                                    {{'CurrentPasswordismandatory' | localize}}
                                                </span>
                                            </div>
                                            <!-- <div *ngIf="myProfileForm.submitted" class="invalid-feedback">
                                                <span *ngIf="currentPasswordInput.touched && currentPasswordInput.errors.required">
                                                    {{'Current Password is required' | localize}} </span>
                                            </div> -->
                                            <div *ngIf="myProfileForm.submitted" class="invalid-feedback">
                                                <span
                                                    *ngIf="currentPasswordInput.invalid && currentPasswordInput.touched">
                                                    {{'ThisFieldIsRequired' | localize}}
                                                </span>
                                            </div>
                                            <div *ngIf="myProfileForm.submitted" class="invalid-feedback">
                                                <span *ngIf="!iscurrentPassword && currentPasswordInput.touched">
                                                    {{'Invalidcurrentpassword' | localize}}
                                                </span>
                                            </div>
                                        </div>
                                        <div *ngIf="isSocial">
                                            <div class="" *ngIf="!showPassword">
                                                <a (click)="showPassword =!showPassword"
                                                    class="blue cursor-pointer">{{'ChangePassword' | localize}}</a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="col-md-12 col-xl-12 col-lg-12 mb-1 mt-2">
                                    <div class="">
                                        <label> {{'Reporting Manager' | localize}}</label>
                                        <div class="input-group">

                                            <input class="form-control rounded-0" id="empName" type="text"
                                                name="empName" #emailAddressInput="ngModel" disabled="disabled"
                                                [(ngModel)]="myProfileData.managerName" maxlength="256">
                                        </div>
                                    </div>
                                </div>

                                    <div *ngIf="isSocial" class="col-md-12 col-xl-12 col-lg-12 mt-3">

                                        <div class="" *ngIf="showPassword">

                                            <div class="input-group">

                                                <input id="NewPassword" name="NewPassword"
                                                       class="form-control rounded-0" #NewPassword="ngModel"
                                                       [type]="fieldTextTypeNewPassword ? 'password' :'text'"
                                                       autocomplete="off" [(ngModel)]="newPassword"
                                                       placeholder="{{'NewPassword' | localize}}"
                                                       validateEqual="NewPasswordRepeat" reverse="true"
                                                       [requireDigit]="true" [requireUppercase]="true"
                                                       [requireLowercase]="true" [requireNonAlphanumeric]="true" [requiredLength]="6"
                                                       [ngClass]="{'borderRed ' : NewPassword.touched && NewPassword.errors?.required}"
                                                       required>

                                                <div class="input-group-prepend">
                                                    <span class="input-group-text rounded-0">
                                                        <i class="fa cursor-pointer"
                                                           [ngClass]="{'fa-eye-slash': fieldTextTypeNewPassword,'fa-eye': !fieldTextTypeNewPassword}"
                                                           (click)="toggleFieldTextTypeNewPassword()"></i>
                                                    </span>
                                                </div>

                                            </div>

                                            <div *ngIf="NewPassword.touched && NewPassword.errors?.required">
                                                <span class="my-profile-password-change-validation">
                                                    {{'MyProfileNewPasswordIsRequired' | localize}}
                                                </span>
                                            </div>

                                            <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
                                                <ul class="form-text text-danger" *ngIf="NewPassword.errors">
                                                    <li [hidden]="!NewPassword.errors.requireDigit">
                                                        {{
"PasswordComplexity_RequireDigit_Hint" |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requireLowercase">
                                                        {{"PasswordComplexity_RequireLowercase_Hint" | localize}}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requireUppercase">
                                                        {{"PasswordComplexity_RequireUppercase_Hint" | localize}}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requireNonAlphanumeric">
                                                        {{"PasswordComplexity_RequireNonAlphanumeric_Hint" | localize}}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requiredLength">
                                                        {{"PasswordComplexity_RequiredLength_Hint" | localize:6}}
                                                    </li>

                                                </ul>
                                            </div>





                                            <!-- <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
        <ul class="form-text text-danger">
            <li [hidden]="!NewPassword.errors.requireDigit">
                {{"PasswordComplexity_RequireDigit_Hint" | localize}}</li>
            <li [hidden]="!NewPassword.errors.requireLowercase">
                {{"PasswordComplexity_RequireLowercase_Hint" | localize}}
            </li>
            <li [hidden]="!NewPassword.errors.requireUppercase">
                {{"PasswordComplexity_RequireUppercase_Hint" | localize}}
            </li>
            <li [hidden]="!NewPassword.errors.requireNonAlphanumeric">
                {{"PasswordComplexity_RequireNonAlphanumeric_Hint" | localize}}
            </li>
            <li [hidden]="!NewPassword.errors.requiredLength">
                {{"PasswordComplexity_RequiredLength_Hint" |
                localize:passwordComplexitySetting.requiredLength}}
            </li>

           <li *ngIf="NewPassword.errors.required && NewPassword.touched">
               {{"New Password cannot be empty"}}
           </li>


        </ul>
    </div> -->

                                        </div>

                                    </div>


                                <div *ngIf="isSocial" class="col-md-12 col-xl-12 col-lg-12  mt-3">
                                    <div class="" *ngIf="showPassword">

                                        <div class="input-group">


                                            <input id="NewPasswordRepeat" name="NewPasswordRepeat"
                                                class="form-control rounded-0" #NewPasswordRepeat="ngModel"
                                                [type]="fieldTextTypeNewPasswordConfirm ? 'password' :'text'"
                                                [(ngModel)]="confirmPassword"
                                                placeholder="{{'ConfirmNewPassword' | localize}}"
                                                validateEqual="NewPassword" reverse="false" autocomplete="off"
                                                [requireDigit]="passwordComplexitySetting.requireDigit"
                                                [requireLowercase]="passwordComplexitySetting.requireLowercase"
                                                [requireUppercase]="passwordComplexitySetting.requireUppercase"
                                                [requireNonAlphanumeric]="passwordComplexitySetting.requireNonAlphanumeric"
                                                [ngClass]="{'borderRed ' : (NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required)|| (!(myProfileForm.form.valid || myProfileForm.form.pristine)&& ((NewPasswordRepeat.errors && NewPasswordRepeat.touched && myProfileForm.submitted)&& !(NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required)))}"
                                                [requiredLength]="passwordComplexitySetting.requiredLength" required>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text rounded-0">
                                                    <i class="fa cursor-pointer"
                                                        [ngClass]="{'fa-eye-slash': fieldTextTypeNewPasswordConfirm,'fa-eye': !fieldTextTypeNewPasswordConfirm}"
                                                        (click)="toggleFieldTextTypeNewPasswordConfirm()"></i>
                                                </span>
                                            </div>


                                        </div>
                                        <div *ngIf="NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required">
                                            <span class="my-profile-password-change-validation">
                                                {{'MyProfileConfirmNewPasswordIsRequired' | localize}}
                                            </span>
                                        </div>
                                        <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
                                            <span
                                                *ngIf="(NewPasswordRepeat.errors && NewPasswordRepeat.touched && myProfileForm.submitted)&& !(NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required)"
                                                class="my-profile-password-change-validation">
                                                {{'PasswordsDontMatch' | localize}}
                                            </span>
                                        </div>


                                        <!-- <span class="help-block text-danger" *ngIf="NewPasswordRepeat.touched && NewPasswordRepeat.errors?.notEqual && !NewPasswordRepeat.errors?.required">
                                            {{'New & Confirm password does not match' | localize}}
                                        </span> -->


                                    </div>
                                </div>

                                <div class="col-md-12 col-lg-12 col-xl-12">
                                    <div class=" mt-2" *ngIf="showPassword">
                                        <a (click)="showPassword =!showPassword" class="cursor-pointer anchor-color">
                                            {{'Cancel' | localize}}
                                        </a>
                                    </div>

                                </div>
                                <!--<div class="col-md-12 mb-2">
                                            <a class="blue mr-2 "> {{'LogOutofAllIntimeProsApps' | localize}}</a>
                                            <span>
                                                <i class="la la-info-circle"
                                                   title="{{'Byclickingonthisoptionyouwilllogoutofallapplicationsacrossalldevicesincludingthisone' | localize}}" data-toggle="tooltip" data-placement="left"></i>
                                            </span>

                                </div>-->
                                <div class="col-md-12 col-lg-12 col-xl-12 mb-2">
                                    <div class="form-group ">
                                        <div class="">
                                            <a class=" mr-2 cursor-pointer" (click)="logOutDevices()">
                                                {{'LogOutofAllIntimeProApps' | localize}}</a>
                                            <span placement="bottom" [tooltip]="tooltip2">
                                                <i class="la la-info-circle" title=""></i>
                                            </span>
                                            <ng-template #tooltip2 class="">
                                                {{'Byclickingonthisoptionyouwilllogoutofallapplicationsacrossalldevicesincludingthisone'
                                                | localize}}
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-12 col-xl-12 col-12 footer mt-3">
                                    <div class="d-flex justify-content-end mb-4 mr-4">
                                        <div class="actions">
                                            <button class="btn btn-square btn-outline-danger px-5 mr-1"
                                                (click)="close()">
                                                {{"Cancel" | localize}}
                                            </button>
                                            <button type="submit" class="btn btn-square btn-primary px-8"
                                                [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"
                                                [disabled]="!isImage && myProfileForm.form.pristine"
                                                form="myProfileForm" (click)="save()">
                                                {{"Save" | localize}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <user-menu style="display:none" #topBarComponentData></user-menu>
            </div>

            <p-sidebar [(visible)]="isSidebarOpen" [blockScroll]="true" position="right" styleClass="p-sidebar-md p-sidebar-bottom" id="ClientProfileModal">
            <!-- <div class="modal right " id="myProfileModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2"> -->
                <!-- <div class="modal-dialog1" role="document">
                    <div class="row h-100">

                        <div class="modal-content"> -->
                            <div class="modal-header">
                                <div class="nav nav-tabs list-bottom" role="tablist">
                                    <a [class.active]="tabIndex==1"
                                        class=" card-title nav-item nav-link  intime-open-sans cursor-pointer font-weight-boldest" id="font-size-side-panel"
                                        aria-checked="true"  (click)="onKey(1)"
                                        aria-selected="false">
                                        {{'UploadanImage' | localize}}
                                    </a>
                                    <a [class.active]="tabIndex==2"
                                        class=" card-title nav-item nav-link intime-open-sans cursor-pointer font-weight-boldest ml-5" id="font-size-side-panel"
                                         aria-checked="true" (click)="onKey(2)"
                                        aria-selected="false">
                                        {{'SelectanAvatar' | localize}}
                                    </a>
                                </div>
                                <!-- <button type="button" class="close mr-4" data-dismiss="modal" aria-label="Close"
                                    style="color:#CA071C">
                                    <span aria-hidden="true">&times;</span>
                                </button> -->

                                <button type="button" class="close " (click)="cancelPhoto()" aria-label="Close"
                                id="customSmall">
                                <i aria-hidden="true" class="ki ki-close"></i>
                                </button>
                            </div>

                            <div class="px-3">
                                <div id="" class="tab-pane side-border mr-4" [class.active]="tabIndex==1"
                                    *ngIf="tabIndex==1">
                                    <div style="border: 1px solid #9EA4AC">
                                        <div class="text-center mt-8">
                                            <div class="image-input-wrapper">
                                                <div *ngIf="showImgModal">
                                                    <img class="border-radius-2 h-115px w-115px rounded"
                                                        *ngIf="imagePathModal != ''" [src]="imagePathModal">
                                                    <img *ngIf="imagePathModal == '' "
                                                        src="assets/common/images/default-profile-picture1.svg"
                                                        class="project-backgroundPhoto rounded" />
                                                </div>
                                                <div *ngIf="showImgModal">
                                                    <label class="mt-3" (click)="removeImage()">
                                                        <a class="blue cursor-pointer">
                                                            {{'RemovePhoto' | localize}}
                                                        </a>
                                                    </label>
                                                </div>
                                            </div>
                                            <div *ngIf="!showImgModal">
                                                <label class="mt-3 " title="">
                                                    <input #fileInput class="" type="file" id="UploadFile"
                                                        style="display: none"
                                                        (change)="getfileContent($event.target.files)"
                                                        name="profile_avatar" accept=".png, .jpg, .jpeg" required>
                                                    <a class="blue cursor-pointer font-size-h6">
                                                        {{'ClickHere' | localize}}
                                                    </a><br />
                                                </label>
                                                <div class="uploadPhoto font-size-h6 font-weight-bolder">
                                                    {{"Touploadyourphoto" |
                                                    localize}}</div>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="text-center mt-10">
                                            <label class="font-size-sm font-weight-bold">{{"RecommendedFormat" |
                                                localize}}</label>
                                        </div>
                                        <div class="text-center">
                                            <label class="font-size-sm font-weight-bold">{{"RecommendedSize" |
                                                localize}}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="float-right mt-10">
                                            <button class="btn btn-square btn-outline-danger px-5 mr-1"
                                                data-dismiss="modal" (click)="cancelPhoto()">
                                                {{"Cancel" | localize}}
                                            </button>
                                            <button class="btn btn-square btn-primary px-8" data-dismiss="modal"
                                                (click)="savePhoto()" [disabled]="!imagePathModal">
                                                {{"Upload" | localize}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div id="" class="tab-pane side-border" [class.active]="tabIndex==2"
                                    *ngIf="tabIndex==2">
                                    <div class="font-size-sm">
                                        {{'Chooseanavatarforyourprofile' | localize}}
                                    </div>
                                    <div class="d-flex align-items-center flex-wrap">
                                        <div *ngFor="let c of photoImage;let i = index" (click)="selectIcon(c.icon , i)"
                                            [ngClass]="{'highlight-avatar': selectedAvatarIndex === i}">
                                            <img class="cursor-pointer mt-3 mr-2 avatar-icon-size" [src]="c.icon"
                                                [id]="'Img'+i">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="float-right mt-10">
                                            <button class="btn btn-square btn-outline-danger px-5 mr-1"
                                                (click)="deletePicture()">
                                                {{"Cancel" | localize}}
                                            </button>
                                            <button class="btn btn-square btn-primary px-8"
                                                (click)="savePhoto()" [disabled]="!imagePathModal">
                                                {{"Upload" | localize}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- </div>
                    </div>
                </div> -->
            <!-- </div> -->
            </p-sidebar>
        </div>
    </div>
</div>
